import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import COLORS from '@zola/zola-ui/src/styles/emotion/colors';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const ModalContainer = styled.div`
  background-color: white;
`;

export const ModalContent = styled.div`
  padding: ${SPACING.S32};
`;

export const Banner = styled.img`
  max-width: 535px;
  width: 100%;
`;

export const Title = styled.p`
  font-family: ${FONT.FONT_FAMILY_PROXIMA};
  font-style: normal;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  font-size: ${FONT.FONT_SIZE_LARGE};
  line-height: 28px;
`;

export const Paragraph = styled.p`
  color: ${COLORS.EMPEROR};
  font-family: ${FONT.FONT_FAMILY_PROXIMA};
  font-style: normal;
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: 24px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${SPACING.MD};
  margin-top: ${SPACING.S24};
`;

export const StyledLink = styled(LinkV2)``;

export const StyledButton = styled(ButtonV3)``;
